(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.DuplicateFileDialogController = (function(superClass) {
    extend(DuplicateFileDialogController, superClass);

    function DuplicateFileDialogController(state, transitions, scope, modalInstance, mups, data, window, rootScope) {
      this.state = state;
      this.transitions = transitions;
      this.scope = scope;
      this.modalInstance = modalInstance;
      this.mups = mups;
      this.window = window;
      this.rootScope = rootScope;
      this.checkProcessedStatus = bind(this.checkProcessedStatus, this);
      this.loadInputFilesProcessingStatus = bind(this.loadInputFilesProcessingStatus, this);
      this.inputFileProcessed = bind(this.inputFileProcessed, this);
      DuplicateFileDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = 'Duplicate Files Detected';
      this.scope.absolute_errors = false;
      this.scope.files = data.files;
      this.scope.files_ids = this.scope.files.map(function(file) {
        return file.input_files_id;
      });
      this.loadInputFilesProcessingStatus();
      this.window.inputFileProcessed = this.inputFileProcessed;
      this.scope.replaceDuplicates = (function(_this) {
        return function() {
          _this.scope.disable_replace = true;
          return _this.mups.replaceDuplicateFiles(_this.scope.files).then(function() {
            _this.modalInstance.close();
            return _this.rootScope.$broadcast('uploads:files_removed');
          });
        };
      })(this);
      this.scope.removeDuplicates = (function(_this) {
        return function() {
          _this.mups.queueRemoval(_this.scope.files);
          return _this.modalInstance.close();
        };
      })(this);
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.rootScope.$broadcast('uploads:clear_message');
        };
      })(this));
    }

    DuplicateFileDialogController.prototype.inputFileProcessed = function(data) {
      var file, i, len, ref;
      ref = this.scope.files;
      for (i = 0, len = ref.length; i < len; i++) {
        file = ref[i];
        if (file.input_files_id === data.input_files_id) {
          file.finished_processing = true;
        }
      }
      this.checkProcessedStatus();
      return this.scope.$apply();
    };

    DuplicateFileDialogController.prototype.loadInputFilesProcessingStatus = function() {
      return this.mups.getInputFilesProcessingStatus(this.scope.files_ids).then((function(_this) {
        return function(response) {
          var f, file, i, j, len, len1, ref, ref1;
          ref = response.data.data;
          for (i = 0, len = ref.length; i < len; i++) {
            file = ref[i];
            ref1 = _this.scope.files;
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              f = ref1[j];
              if (!(f.id === file.input_files_id && (f.finished_processing == null))) {
                continue;
              }
              f.finished_processing = file.finished_processing;
              break;
            }
          }
          return _this.checkProcessedStatus();
        };
      })(this));
    };

    DuplicateFileDialogController.prototype.checkProcessedStatus = function() {
      var all_processed, file, i, len, ref;
      all_processed = true;
      ref = this.scope.files;
      for (i = 0, len = ref.length; i < len; i++) {
        file = ref[i];
        if (!((file.finished_processing == null) || !file.finished_processing)) {
          continue;
        }
        all_processed = false;
        break;
      }
      return this.scope.disable_replace = all_processed ? false : true;
    };

    return DuplicateFileDialogController;

  })(DialogController);

}).call(this);
